import type { FC } from "react";
import { useTranslation } from "@privacy/translations";
import { useMutation } from "@tanstack/react-query";
import type { ClassificationCustomerCustomizations, ClassificationTemplate } from "../../../api/classificationTemplate";
import { updateSystemClassificationOverrideMutationOptions, type SystemClassification } from "../../../api/systems";
import { ClassificationCard } from "../../../classification/ClassificationCard";
import { DynamicForm } from "../../../dynamicForm";

type Props = {
  systemId: string;
  classification: SystemClassification;
  template: ClassificationTemplate;
  customerCustomizations: ClassificationCustomerCustomizations;
  canEdit: boolean;
};

export const SystemClassificationSection: FC<Props> = ({
  systemId,
  classification,
  template,
  customerCustomizations,
  canEdit,
}) => {
  const { t } = useTranslation();
  const updateMutation = useMutation(updateSystemClassificationOverrideMutationOptions(systemId));

  const { override, criticality } = classification;
  return (
    <DynamicForm.InlineFormSection
      title={t("System.Classification.SectionTitle")}
      subtitle={t("System.Classification.SectionSubtitle")}
    >
      <ClassificationCard
        key={`${systemId}-${override ? "override" : "auto"}`}
        template={template}
        customerCustomizations={customerCustomizations}
        scores={override ? override.scores : []}
        criticality={criticality}
        rationale={override?.rationale}
        isReadOnly={!canEdit}
        onSave={updateMutation.mutateAsync}
      />
    </DynamicForm.InlineFormSection>
  );
};
